import "../stylesheets/application"
import "@fortawesome/fontawesome-free/css/all"
import "bootstrap"
import "channels"
import * as ActiveStorage from "@rails/activestorage"
import DePayWidgets from "@depay/widgets"
import payment from "../payment"
import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import { ethers } from 'ethers'

Rails.start()
Turbolinks.start()
ActiveStorage.start()

window.payment = payment

window.DePayWidgets = DePayWidgets // expose to mock in tests
